import Announcement from './Index.vue'

/* istanbul ignore next */
Announcement.install = function (Vue) {
  Vue.component(Announcement.name, Announcement)
}

export default Announcement
